/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TodosWidgetContainer_widget$ref: FragmentReference;
declare export opaque type TodosWidgetContainer_widget$fragmentType: TodosWidgetContainer_widget$ref;
export type TodosWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: TodosWidgetContainer_widget$ref,
|};
export type TodosWidgetContainer_widget$data = TodosWidgetContainer_widget;
export type TodosWidgetContainer_widget$key = {
  +$data?: TodosWidgetContainer_widget$data,
  +$fragmentRefs: TodosWidgetContainer_widget$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TodosWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visible",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "data",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1d2e22c7aecfad49a1b3fe27b76b718e';
module.exports = node;
